/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetAnimalQueryResponse, GetAnimalPathParams, GetAnimal400, GetAnimal401, GetAnimal403, GetAnimal404, GetAnimal409, GetAnimal500 } from "../../types/livestockController/GetAnimal.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getAnimal } from "../../client/livestockController/getAnimal.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getAnimalQueryKey = (organizationId: GetAnimalPathParams["organizationId"] | undefined, animalId: GetAnimalPathParams["animalId"] | undefined) => [{ url: '/api/organizations/:organizationId/livestock/animals/:animalId', params: {organizationId:organizationId,animalId:animalId} }] as const

export type GetAnimalQueryKey = ReturnType<typeof getAnimalQueryKey>

export function getAnimalQueryOptions(organizationId: GetAnimalPathParams["organizationId"] | undefined, animalId: GetAnimalPathParams["animalId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getAnimalQueryKey(organizationId, animalId)
        return queryOptions<GetAnimalQueryResponse, ResponseErrorConfig<GetAnimal400 | GetAnimal401 | GetAnimal403 | GetAnimal404 | GetAnimal409 | GetAnimal500>, GetAnimalQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && animalId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getAnimal(organizationId!, animalId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get animal profile
 * {@link /api/organizations/:organizationId/livestock/animals/:animalId}
 */
export function useGetAnimal<TData = GetAnimalQueryResponse, TQueryData = GetAnimalQueryResponse, TQueryKey extends QueryKey = GetAnimalQueryKey>(organizationId: GetAnimalPathParams["organizationId"] | undefined, animalId: GetAnimalPathParams["animalId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetAnimalQueryResponse, ResponseErrorConfig<GetAnimal400 | GetAnimal401 | GetAnimal403 | GetAnimal404 | GetAnimal409 | GetAnimal500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getAnimalQueryKey(organizationId, animalId)
         

         const query = useQuery({
          ...getAnimalQueryOptions(organizationId, animalId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetAnimal400 | GetAnimal401 | GetAnimal403 | GetAnimal404 | GetAnimal409 | GetAnimal500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}